import { autoRedirect } from '@/utils/auto_redirect'
import { nativeRedirect } from '@/utils/native_interactions/native_redirect'
import { nativeRoutes } from '@/utils/native_interactions/native_redirect/routes'

export const redirectPlugin = {
  install(Vue) {
    Vue.prototype.$autoRedirect = function () {
      autoRedirect(...arguments)
    }
    Vue.prototype.$nativeRedirect = function () {
      nativeRedirect(...arguments)
    }
    Vue.prototype.$nativeRoutes = nativeRoutes
  }
}
